import {networkLayer} from "./networkLayer";
import {config} from "../config";
import {MultipleDeviceInterface} from "./device";

export const getDMSConfigs = async (values: any, idStudy: string) => {
    return await networkLayer('post', `${config.dataUrls}/dashboard/dms_study/${idStudy}/`, values);
}
